import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    class: "game-card",
    onClick: _ctx.goToGameHelper
  }, {
    header: _withCtx(() => [
      _createElementVNode("img", {
        class: "board-game-image",
        alt: "game board image",
        src: _ctx.imageSrc
      }, null, 8, _hoisted_1)
    ]),
    content: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.name), 1)
    ]),
    _: 1
  }, 8, ["onClick"]))
}